import React from "react";
import { Link, useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import Logo from "../../components/Logo";
import { HiOutlineLogout } from "react-icons/hi";
import { MdWorkspacesOutline } from "react-icons/md";
import { signOut } from "../../store/actions/AuthActions";

function Project() {
  const projects = [
    {
      name: "RW-0622 Rwamagana",
      role: "User",
    },
  ];

  const history = useHistory();
  const dispatch = useDispatch();
  const handleSignOut = () => {
    dispatch(signOut());
    history.push("/");
  };

  return (
    <div className="flex min-h-screen w-full">
      <div className="h-14 bg-indigo-50 text-gray-500 w-full border-b border-gray-200  px-10 flex flex-row fixed z-10">
        <Link to="/projects" className="my-auto">
          <Logo />
        </Link>

        {/* user profile */}
        <div className="px-2 py-2 flex flex-row text-xs font-medium text-white m-auto ml-auto mr-0">
          <img
            src="https://i1.pngguru.com/preview/137/834/449/cartoon-cartoon-character-avatar-drawing-film-ecommerce-facial-expression-png-clipart.jpg"
            className="w-8 h-8 rounded-full pl-0"
            alt="user"
          />
        </div>
        {/* logout  */}
        <div
          message="Logout"
          className="text-xs my-auto mx-2 title-tip inline-block"
        >
          <button
            className="flex flex-row  font-medium"
            onClick={() => {
              handleSignOut();
            }}
          >
            <HiOutlineLogout className="text-xl" />{" "}
          </button>
        </div>
      </div>
      <div className="m-auto flex flex-col  rounded text-gray-500  w-80 md:w-2/4">
        <h2 className="font-semibold m-auto my-3 text-indigo-500 text-sm">
          Choose project workspace
        </h2>
        <div className="text-xs">
          {projects.map((project, i) => {
            return (
              <Link to="/home" key={i}>
                <div
                  className="flex  bg-gray-50 border border-gray-200 mt-2 rounded  p-5 hover:border-indigo-200 cursor-pointer"
                  key={i}
                >
                  <div className="flex">
                    <MdWorkspacesOutline className="mx-2  my-auto text-gray-500" />{" "}
                    <h2 className="font-medium my-auto">{project.name}</h2>
                  </div>
                  <p className="text-indigo-500 bg-indigo-100 fit-content px-2 rounded ml-auto border border-indigo-200">
                    {"Continue as " + project.role}
                  </p>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default Project;
